import { ApiAuthService } from '../../services/backend/public/api-auth/api-auth.service';
import { Component, signal } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { inject } from '@angular/core';
import { GovcoFooterComponent } from '../layout/govco-footer/govco-footer.component';
import { GovcoHeaderComponent } from '../layout/govco-header/govco-header.component';

@Component({
  selector: 'sr-psa-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, GovcoHeaderComponent, GovcoFooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  host: { '[style.--app-navigation-width]': "navigationCollapsed() ? '76px' : '360px'" }
})
export class AppComponent {
  readonly navigationCollapsed = signal(false);
  readonly router = inject(Router);
  readonly auth = inject(ApiAuthService);
  logout(): void {
    this.auth.logout().subscribe({ error: () => { void this.router.navigateByUrl('/inicio-sesion'); } });
  }
}
